module.exports = __webpack_public_path__ + "img/f4.c71ad444.jpg";